module.exports = __webpack_public_path__ + "img/LandschaftI.2bcecdf0.jpg";